export default "<div class=\"full-height full-width\">\n  <!-- {{configuration | json}} -->\n  <ng-template addHost></ng-template>\n</div>\n"